import workspaceQuery from '../../../graphql/queries/sales/ImportedEbayOrderWorkspaceQuery.graphql';
import listQuery from '../../../graphql/queries/sales/ImportedEbayOrderListQuery.graphql';
import instanceQuery from '../../../graphql/queries/sales/ImportedEbayOrderQuery.graphql';
import mutationQuery from '../../../graphql/mutations/sales/ImportedEbayOrderMutation.graphql';
import fragment from '../../../graphql/fragments/sales/ImportedEbayOrderFragment.graphql';
import aggregateQuery from '../../../graphql/queries/sales/ImportedEbayOrderAggregateQuery.graphql';
import { workspace } from '../../../actions/sales/ImportedOrderWorkspaceAction';
import { ALLOW_VIEW } from '../../../utils/OperationPermissions';
import { EntityType } from '../../../@types/entityTypes';

const ImportedEbayOrder: EntityType = {
  type: 'ImportedEbayOrder',
  title: 'Ebay Orders',
  formTitle: 'Imported Ebay Order',
  workspaceUrl: '/Sales/Channel/ImportedEbayOrder/Workspace/',
  formUrl: '/Sales/Channel/ImportedEbayOrder/Details/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'orderReference',
  },
  fragment,
  aggregate: aggregateQuery,
  screenReference: 'IMPORTED_EBAY_ORDERS',
  actions: workspace,
  operations: ALLOW_VIEW,
};

export default ImportedEbayOrder;
